import mixpanel from "mixpanel-browser";

let isInitialized = false;

export const initMixpanel = () => {
  if (isInitialized) return;

  const token = process.env.REACT_APP_MIXPANEL_TOKEN;

  if (!token) {
    // console.warn("❌ Mixpanel token missing");
    return;
  }

  mixpanel.init(token, {
    debug: true,
    track_pageview: true,
    persistence: "localStorage",
  });

  isInitialized = true;

  // console.log("✅ Mixpanel initialized");
};

export const trackEvent = (eventName, properties = {}) => {
  if (!isInitialized) {
    // console.warn("⚠️ Mixpanel not initialized. Call initMixpanel()");
    return;
  }

  mixpanel.track(eventName, properties);
};

export const identifyUser = (userId) => {
  if (!isInitialized || !userId) return;

  mixpanel.identify(userId);
};


export default mixpanel;
